import BaseFactory from 'services/sports/default/base-factory';
import Const from 'constants';
import LineupClassic from 'services/sports/tennis/lineup/lineup-classic';

class Factory extends BaseFactory {
    createObj(objectName, params) {
        const {sportConfig} = params;
        const gameType = sportConfig.getGameType();

        const classesMap = {
            [Const.GAME_TYPE_CLASSIC]: LineupClassic,
        };

        if (gameType in classesMap) {
            return new classesMap[gameType](params);
        }

        throw new Error(`Unknown gameType "${gameType}".`);
    }
}

export {Factory};
